<div class="trip-flow-dialog">

  <!-- ── Header ─────────────────────────────────────────── -->
  <div class="trip-flow-dialog__header">
    <div class="trip-flow-dialog__header-icon">
      <mat-icon class="text-white" style="font-size:32px;width:32px;height:32px;">
        {{ step === 'airport' ? 'local_airport' : 'explore' }}
      </mat-icon>
    </div>
    <div>
      <h2 class="trip-flow-dialog__title">
        {{ (step === 'airport' ? 'TRIP_FLOW.STEP2_TITLE' : 'TRIP_FLOW.STEP1_TITLE') | translate }}
      </h2>
      <p class="trip-flow-dialog__subtitle">
        {{ (step === 'airport' ? 'TRIP_FLOW.STEP2_SUBTITLE' : 'TRIP_FLOW.STEP1_SUBTITLE') | translate }}
      </p>
    </div>
  </div>

  <!-- ── Step 1 — Choose use case ───────────────────────── -->
  @if (step === 'usecase') {
    <div class="trip-flow-dialog__body">

      <div class="trip-flow-dialog__cards">
        @for (uc of useCases; track uc.id) {
          <button
            class="trip-flow-dialog__card"
            [class.trip-flow-dialog__card--selected]="selectedUseCase === uc.id"
            (click)="selectUseCase(uc.id)"
            type="button"
          >
            <span
              class="trip-flow-dialog__card-icon-wrap"
              [style.background]="'linear-gradient(135deg,' + uc.accentColor + '22 0%,' + uc.accentColor + '11 100%)'"
              [style.border-color]="uc.accentColor + '44'"
            >
              <mat-icon [style.color]="uc.accentColor">{{ uc.icon }}</mat-icon>
            </span>
            <span class="trip-flow-dialog__card-title">{{ uc.titleKey | translate }}</span>
            <span class="trip-flow-dialog__card-subtitle">{{ uc.subtitleKey | translate }}</span>
          </button>
        }
      </div>

      <div class="trip-flow-dialog__skip">
        <button mat-button type="button" (click)="skip()" class="trip-flow-dialog__skip-btn">
          <mat-icon class="mr-1" style="font-size:16px;width:16px;height:16px;line-height:16px;">close</mat-icon>
          {{ 'TRIP_FLOW.SKIP' | translate }}
        </button>
      </div>

    </div>
  }

  <!-- ── Step 2 — Choose airport ────────────────────────── -->
  @if (step === 'airport') {
    <div class="trip-flow-dialog__body">

      <button mat-button type="button" (click)="goBack()" class="trip-flow-dialog__back-btn">
        <mat-icon>arrow_back</mat-icon>
        {{ 'TRIP_FLOW.BACK' | translate }}
      </button>

      <div class="trip-flow-dialog__airport-list">
        @for (retailer of retailers; track retailer.retailerId) {
          <button
            class="trip-flow-dialog__airport-card"
            type="button"
            (click)="selectRetailer(retailer)"
          >
            <span class="trip-flow-dialog__airport-icon-wrap">
              <mat-icon style="color:#F4BE00">local_airport</mat-icon>
            </span>
            <span class="trip-flow-dialog__airport-info">
              <span class="trip-flow-dialog__airport-name">{{ retailer.displayTitle }}</span>
              @if (retailer.cityName) {
                <span class="trip-flow-dialog__airport-city">{{ retailer.cityName }}</span>
              }
            </span>
            <mat-icon class="trip-flow-dialog__airport-chevron">chevron_right</mat-icon>
          </button>
        }

        @if (!retailers.length) {
          <div class="trip-flow-dialog__empty">
            <mat-progress-spinner diameter="32" mode="indeterminate" color="primary"></mat-progress-spinner>
          </div>
        }
      </div>

    </div>
  }

</div>
